/* eslint-disable @typescript-eslint/no-explicit-any */

import { BarRounded } from '@visx/shape';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function Bars(_ref) {
  let {
    bars,
    horizontal,
    xScale,
    yScale,
    radius,
    radiusAll,
    radiusTop,
    radiusRight,
    radiusBottom,
    radiusLeft,
    ...restProps
  } = _ref;
  const isFocusable = Boolean(restProps.onFocus || restProps.onBlur);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: bars.map(_ref2 => {
      let {
        key,
        ...barProps
      } = _ref2;
      return radius == null ? /*#__PURE__*/_jsx("rect", {
        className: "visx-bar",
        tabIndex: isFocusable ? 0 : undefined,
        ...barProps,
        ...restProps
      }, key) : /*#__PURE__*/_jsx(BarRounded, {
        className: "visx-bar",
        tabIndex: isFocusable ? 0 : undefined,
        radius: radius,
        all: radiusAll,
        top: radiusTop,
        right: radiusRight,
        bottom: radiusBottom,
        left: radiusLeft,
        ...barProps,
        ...restProps
      }, key);
    })
  });
}